import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReferenceDataLabels } from '../../../../lib/constants/reference-data-labels';
import { ReferenceDataService } from '../../../../lib/services/reference-data.service';
import { RomeNotificationService } from '../../../../lib/services/rome-notification.service';
import { KfiStore } from '../../services/kfi-store';
import { KfiService } from './../../services/kfi.service';

@Component({
  selector: 'boi-save-kfi',
  templateUrl: './save-kfi.component.html',
  styleUrls: ['./save-kfi.component.scss']
})
export class SaveKfiComponent implements OnDestroy {
  @Input() public isFieldDisabled: boolean;
  @Input() public saveButtonLabel: string;

  @Output() public readonly save = new EventEmitter<any>();
  @Output() public readonly cancel = new EventEmitter<any>();

  public referenceDataLabels = ReferenceDataLabels;

  private readonly destroySubject$ = new Subject();

  constructor(
    private readonly kfiStore: KfiStore,
    private readonly kfiService: KfiService,
    private readonly notificationsService: RomeNotificationService,
    private readonly referenceDataService: ReferenceDataService
  ) {}

  public refreshKfi(): void {
    this.kfiService
      .loadKfi(this.kfiStore.kfiId)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data) => {
        data.IsSubmitted = this.kfiStore.isSubmitted;
        this.kfiStore.kfiResponse = data;
      });
  }

  public saveKfi(): void {
    this.kfiService
      .saveKfi(this.kfiService.prepareData(this.kfiStore.kfiResponse.Entity))
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(
        (data) => {
          data.IsSubmitted = this.kfiStore.isSubmitted;
          this.kfiStore.kfiResponse = data;

          if (data.IsSubmitted) {
            data.ValidationErrors.BusinessValidationErrors = data.ValidationErrors.FullValidationErrors;
          }

          if (data.ValidationErrors.BusinessValidationErrors.length > 1) {
            const localizedMessage = this.referenceDataService.getLocalizeLabel(
              this.referenceDataLabels.NotificationValidationErrors
            );
            this.notificationsService.showError(localizedMessage);
          } else {
            const localizedMessage = this.referenceDataService.getLocalizeLabel(
              this.referenceDataLabels.NotificationSaveSuccess
            );
            this.notificationsService.showInfo(localizedMessage);
          }
          this.save.emit();
        },
        (error) => {}
      );
  }

  public ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
